import http from "@/settings/apiSettings"

class CrmKPIDataService {

  // ─── KPIDefinitie (OData) ────────────────────────────────────────────────

  getDefinitii(params?: Record<string, string>): Promise<any> {
    return http.clientComercialOdata.get("/CRM_KPIDefinitie", { params })
  }

  saveDefinitie(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_KPIDefinitie", data)
  }

  updateDefinitie(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_KPIDefinitie(${key})`, data)
  }

  deleteDefinitie(key: string): Promise<any> {
    return http.clientComercialOdata.delete(`/CRM_KPIDefinitie(${key})`)
  }

  // ─── KPIAgent (OData) ────────────────────────────────────────────────────

  getAgenti(params?: Record<string, string>): Promise<any> {
    return http.clientComercialOdata.get("/CRM_KPIAgent", { params })
  }

  saveAgent(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_KPIAgent", data)
  }

  updateAgent(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_KPIAgent(${key})`, data)
  }

  deleteAgent(key: string): Promise<any> {
    return http.clientComercialOdata.delete(`/CRM_KPIAgent(${key})`)
  }

  // ─── KPITargetUser (OData) ───────────────────────────────────────────────

  getTargeturiUser(params?: Record<string, string>): Promise<any> {
    return http.clientComercialOdata.get("/CRM_KPITargetUser", { params })
  }

  saveTargetUser(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_KPITargetUser", data)
  }

  updateTargetUser(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_KPITargetUser(${key})`, data)
  }

  deleteTargetUser(key: string): Promise<any> {
    return http.clientComercialOdata.delete(`/CRM_KPITargetUser(${key})`)
  }

  // ─── Raport KPI (REST) ───────────────────────────────────────────────────

  getRaport(utilizator: string, an: number, luna: number): Promise<any> {
    return http.clientComercial.get("/CRM_KPIRaport/GetRaport", {
      params: { utilizator, an, luna }
    })
  }

  getEchipaRaport(an: number, luna: number): Promise<any> {
    return http.clientComercial.get("/CRM_KPIRaport/GetEchipaRaport", {
      params: { an, luna }
    })
  }

  getDetaliu(utilizator: string, an: number, luna: number, sursaDate: string): Promise<any> {
    return http.clientComercial.get("/CRM_KPIRaport/GetDetaliu", {
      params: { utilizator, an, luna, sursaDate }
    })
  }
}

export default new CrmKPIDataService()
